export const Companies = axios => ({

  create (payload) {
    payload.name_deleted = payload.name
    return axios.post('/v1/companies', payload)
  },

  list: {
    short (params) {
      params.show_unassigned = params.show_unassigned ? 1 : 0
      params.only_parentable = params.only_parentable ? 1 : 0
      return axios.get('/v1/companies', { params })
    }
  }

})
